import root from 'window-or-global';
import React from 'react';
import {getLocale} from '@epic-core/common';
import getTagsFromModel from 'epic-node-cms/src/cmsUtils/metaUtils';
import Helmet from 'react-helmet';

const getBasicMetaTags = getMessage => [
    {property: 'twitter:site', content: getMessage('epic.diesel.social.meta.twitter_account')},
    {property: 'og:site_name', content: getMessage('epic.diesel.social.meta.site_name')}
];

const getMetaTags = (getMessage, title, desc, img) => {
    let description = '';
    const fbImage = img;
    const twImage = img;
    const locale = getLocale();
    if (desc) {
        //escape html tags
        description = desc.replace(/(<([^>]+)>)/gi, '');
    } else {
        description = getMessage('epic.diesel.social.meta.site_description');
    }
    const socialMeta = {
        locale: locale ? locale.replace('-', '_') : locale,
        description,
        fbImage,
        twImage,
        title: title || getMessage('epic.diesel.home.title')
    };

    const ogUrl = root.location.href;
    const tags = [
        {property: 'og:url', content: ogUrl},
        {property: 'og:locale', content: socialMeta.locale},
        {property: 'og:type', content: 'website'},
        {property: 'og:description', content: socialMeta.description},
        {property: 'description', content: socialMeta.description},
        {property: 'og:image', content: socialMeta.fbImage},
        {property: 'og:title', content: socialMeta.title},
        {name: 'twitter:description', content: socialMeta.description},
        {name: 'twitter:image', content: socialMeta.twImage},
        {name: 'twitter:title', content: socialMeta.title},
        {name: 'twitter:card', content: 'summary_large_image'}
    ];

    return tags.concat(getBasicMetaTags(getMessage));
};

const getHelmetByTitleDesc = (getMessage, title, desc, img) => {
    const tags = getMetaTags(getMessage, title, desc, img);

    return <Helmet meta={tags} title={title || getMessage('epic.diesel.home.title')} />;
};

const getHelmetByModel = (getMessage, pageModel) => {
    if (!pageModel) return null;

    const {tags, title} = getTagsFromModel(pageModel);

    return <Helmet meta={tags} title={title || getMessage('epic.diesel.home.title')} />;
};

const getHrefAlternateLoc = (baseUrl, uri, supportedLocales) => {
    if (!supportedLocales) return null;
    // NOTE: Passing links to Helmet as react elements causes a runaway deepEqual compare loop
    // ... on children of the Helmet component, instead if we pass them as an array to the `link`
    // ... prop, it solves the compare issues.
    // @see https://github.com/nfl/react-helmet/issues/373
    const links = supportedLocales.map(locale => ({
        rel: 'alternate',
        hrefLang: locale,
        key: locale,
        href: `${root.location.origin}${baseUrl}${locale}${uri}`
    }));

    return <Helmet link={links} />;
};

export {getMetaTags, getHelmetByTitleDesc, getBasicMetaTags, getHelmetByModel, getHrefAlternateLoc};
